import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

// react-select 5 wrapper. v1's react-virtualized-select is dropped (v5 auto-sizes
// option rows to content, so no windowing). `classNamePrefix="Select"` makes v5
// emit the `.Select__*` BEM classes the app SCSS targets, and every consumer
// inherits it from here. Consumers reach the inner select via a ref and call
// `.focus()` (from an <h4 onClick>), so we hold the inner ref and expose focus().
//
// `classNames={{ container }}`: v5's OUTER container is the one element that does
// NOT get a `Select__*` base class (it carries only the emotion hash +
// `--state` modifiers), so the prod-era `.Select__container { margin; width }`
// rules ported during the react-select 1->5 upgrade were dead selectors — selects rendered
// touching + full-width vs prod. Re-attach the class explicitly here. Direct
// (non-WdSelect) `<Select>` sites do the same next to their `classNamePrefix`.
class WdSelect extends React.Component {
  focus() {
    if (this._select) {
      this._select.focus();
    }
  }

  render() {
    return (
      <Select
        ref={(s) => { this._select = s; }}
        classNamePrefix="Select"
        {...this.props}
        classNames={{ container: () => "Select__container" }}
      />
    );
  }
}

WdSelect.propTypes = {
  name: PropTypes.string.isRequired
};

export default WdSelect;
